// source: v2/types/billing.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var v2_types_group_pb = require('../../v2/types/group_pb.js');
goog.object.extend(proto, v2_types_group_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.AccountStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.AdvancedPayment', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.BillingEntity', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.BillingEntity.RegionCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.BillingPeriod', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.BillingPeriodStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.CanadianProvince', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ChargeGroup', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.Commitment', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.Credit', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.HierarchyCommitment', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.HierarchyGroup', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.OneOffCharge', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.Product', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UsState', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.Product.displayName = 'proto.loopup.ctgateway.v2.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.BillingPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.BillingPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.BillingPeriod.displayName = 'proto.loopup.ctgateway.v2.BillingPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.OneOffCharge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.OneOffCharge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.OneOffCharge.displayName = 'proto.loopup.ctgateway.v2.OneOffCharge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.Credit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.Credit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.Credit.displayName = 'proto.loopup.ctgateway.v2.Credit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AdvancedPayment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AdvancedPayment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AdvancedPayment.displayName = 'proto.loopup.ctgateway.v2.AdvancedPayment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.Commitment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.Commitment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.Commitment.displayName = 'proto.loopup.ctgateway.v2.Commitment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.ChargeGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.ChargeGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.ChargeGroup.displayName = 'proto.loopup.ctgateway.v2.ChargeGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.HierarchyCommitment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.HierarchyCommitment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.HierarchyCommitment.displayName = 'proto.loopup.ctgateway.v2.HierarchyCommitment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.HierarchyGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.HierarchyGroup.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.HierarchyGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.HierarchyGroup.displayName = 'proto.loopup.ctgateway.v2.HierarchyGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.BillingEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.loopup.ctgateway.v2.BillingEntity.oneofGroups_);
};
goog.inherits(proto.loopup.ctgateway.v2.BillingEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.BillingEntity.displayName = 'proto.loopup.ctgateway.v2.BillingEntity';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chargeGroup: (f = msg.getChargeGroup()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    salesforceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sku: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.Product}
 */
proto.loopup.ctgateway.v2.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.Product;
  return proto.loopup.ctgateway.v2.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.Product}
 */
proto.loopup.ctgateway.v2.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setChargeGroup(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalesforceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChargeGroup();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSalesforceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Product.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Product} returns this
 */
proto.loopup.ctgateway.v2.Product.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue charge_group = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Product.prototype.getChargeGroup = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Product} returns this
*/
proto.loopup.ctgateway.v2.Product.prototype.setChargeGroup = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Product} returns this
 */
proto.loopup.ctgateway.v2.Product.prototype.clearChargeGroup = function() {
  return this.setChargeGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Product.prototype.hasChargeGroup = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string salesforce_id = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Product.prototype.getSalesforceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Product} returns this
 */
proto.loopup.ctgateway.v2.Product.prototype.setSalesforceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string sku = 4;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Product.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Product} returns this
 */
proto.loopup.ctgateway.v2.Product.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Product.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Product} returns this
 */
proto.loopup.ctgateway.v2.Product.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_active = 6;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Product.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.Product} returns this
 */
proto.loopup.ctgateway.v2.Product.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.BillingPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.BillingPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.BillingPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDateTime: (f = msg.getStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDateTime: (f = msg.getEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    canAddCharges: (f = msg.getCanAddCharges()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod}
 */
proto.loopup.ctgateway.v2.BillingPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.BillingPeriod;
  return proto.loopup.ctgateway.v2.BillingPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.BillingPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod}
 */
proto.loopup.ctgateway.v2.BillingPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDateTime(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDateTime(value);
      break;
    case 3:
      var value = /** @type {!proto.loopup.ctgateway.v2.BillingPeriodStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCanAddCharges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.BillingPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.BillingPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.BillingPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDateTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCanAddCharges();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_date_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.getStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod} returns this
*/
proto.loopup.ctgateway.v2.BillingPeriod.prototype.setStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod} returns this
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.clearStartDateTime = function() {
  return this.setStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.hasStartDateTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_date_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.getEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod} returns this
*/
proto.loopup.ctgateway.v2.BillingPeriod.prototype.setEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod} returns this
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.clearEndDateTime = function() {
  return this.setEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.hasEndDateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional BillingPeriodStatus status = 3;
 * @return {!proto.loopup.ctgateway.v2.BillingPeriodStatus}
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.getStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.BillingPeriodStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.BillingPeriodStatus} value
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod} returns this
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.BoolValue can_add_charges = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.getCanAddCharges = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod} returns this
*/
proto.loopup.ctgateway.v2.BillingPeriod.prototype.setCanAddCharges = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod} returns this
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.clearCanAddCharges = function() {
  return this.setCanAddCharges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingPeriod.prototype.hasCanAddCharges = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.OneOffCharge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.OneOffCharge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.OneOffCharge.toObject = function(includeInstance, msg) {
  var f, obj = {
    quantity: jspb.Message.getFieldWithDefault(msg, 1, 0),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    product: (f = msg.getProduct()) && proto.loopup.ctgateway.v2.Product.toObject(includeInstance, f),
    billingEntityName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    chargeDateTime: (f = msg.getChargeDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    billingPeriod: (f = msg.getBillingPeriod()) && proto.loopup.ctgateway.v2.BillingPeriod.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge}
 */
proto.loopup.ctgateway.v2.OneOffCharge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.OneOffCharge;
  return proto.loopup.ctgateway.v2.OneOffCharge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.OneOffCharge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge}
 */
proto.loopup.ctgateway.v2.OneOffCharge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = new proto.loopup.ctgateway.v2.Product;
      reader.readMessage(value,proto.loopup.ctgateway.v2.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setChargeDateTime(value);
      break;
    case 8:
      var value = new proto.loopup.ctgateway.v2.BillingPeriod;
      reader.readMessage(value,proto.loopup.ctgateway.v2.BillingPeriod.deserializeBinaryFromReader);
      msg.setBillingPeriod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.OneOffCharge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.OneOffCharge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.OneOffCharge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.loopup.ctgateway.v2.Product.serializeBinaryToWriter
    );
  }
  f = message.getBillingEntityName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getChargeDateTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBillingPeriod();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.loopup.ctgateway.v2.BillingPeriod.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 quantity = 1;
 * @return {number}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double price = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Product product = 4;
 * @return {?proto.loopup.ctgateway.v2.Product}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.getProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v2.Product} */ (
    jspb.Message.getWrapperField(this, proto.loopup.ctgateway.v2.Product, 4));
};


/**
 * @param {?proto.loopup.ctgateway.v2.Product|undefined} value
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
*/
proto.loopup.ctgateway.v2.OneOffCharge.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string billing_entity_name = 5;
 * @return {string}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.getBillingEntityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.setBillingEntityName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string currency_code = 6;
 * @return {string}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp charge_date_time = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.getChargeDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
*/
proto.loopup.ctgateway.v2.OneOffCharge.prototype.setChargeDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.clearChargeDateTime = function() {
  return this.setChargeDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.hasChargeDateTime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional BillingPeriod billing_period = 8;
 * @return {?proto.loopup.ctgateway.v2.BillingPeriod}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.getBillingPeriod = function() {
  return /** @type{?proto.loopup.ctgateway.v2.BillingPeriod} */ (
    jspb.Message.getWrapperField(this, proto.loopup.ctgateway.v2.BillingPeriod, 8));
};


/**
 * @param {?proto.loopup.ctgateway.v2.BillingPeriod|undefined} value
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
*/
proto.loopup.ctgateway.v2.OneOffCharge.prototype.setBillingPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge} returns this
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.clearBillingPeriod = function() {
  return this.setBillingPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.OneOffCharge.prototype.hasBillingPeriod = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.Credit.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.Credit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.Credit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Credit.toObject = function(includeInstance, msg) {
  var f, obj = {
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    product: (f = msg.getProduct()) && proto.loopup.ctgateway.v2.Product.toObject(includeInstance, f),
    billingEntityName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    chargeDateTime: (f = msg.getChargeDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    billingPeriod: (f = msg.getBillingPeriod()) && proto.loopup.ctgateway.v2.BillingPeriod.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.Credit}
 */
proto.loopup.ctgateway.v2.Credit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.Credit;
  return proto.loopup.ctgateway.v2.Credit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.Credit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.Credit}
 */
proto.loopup.ctgateway.v2.Credit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = new proto.loopup.ctgateway.v2.Product;
      reader.readMessage(value,proto.loopup.ctgateway.v2.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setChargeDateTime(value);
      break;
    case 7:
      var value = new proto.loopup.ctgateway.v2.BillingPeriod;
      reader.readMessage(value,proto.loopup.ctgateway.v2.BillingPeriod.deserializeBinaryFromReader);
      msg.setBillingPeriod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.Credit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.Credit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.Credit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Credit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.loopup.ctgateway.v2.Product.serializeBinaryToWriter
    );
  }
  f = message.getBillingEntityName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getChargeDateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBillingPeriod();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.loopup.ctgateway.v2.BillingPeriod.serializeBinaryToWriter
    );
  }
};


/**
 * optional double price = 1;
 * @return {number}
 */
proto.loopup.ctgateway.v2.Credit.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
 */
proto.loopup.ctgateway.v2.Credit.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Credit.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
 */
proto.loopup.ctgateway.v2.Credit.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Product product = 3;
 * @return {?proto.loopup.ctgateway.v2.Product}
 */
proto.loopup.ctgateway.v2.Credit.prototype.getProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v2.Product} */ (
    jspb.Message.getWrapperField(this, proto.loopup.ctgateway.v2.Product, 3));
};


/**
 * @param {?proto.loopup.ctgateway.v2.Product|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
*/
proto.loopup.ctgateway.v2.Credit.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
 */
proto.loopup.ctgateway.v2.Credit.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Credit.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string billing_entity_name = 4;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Credit.prototype.getBillingEntityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
 */
proto.loopup.ctgateway.v2.Credit.prototype.setBillingEntityName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string currency_code = 5;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Credit.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
 */
proto.loopup.ctgateway.v2.Credit.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp charge_date_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.Credit.prototype.getChargeDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
*/
proto.loopup.ctgateway.v2.Credit.prototype.setChargeDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
 */
proto.loopup.ctgateway.v2.Credit.prototype.clearChargeDateTime = function() {
  return this.setChargeDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Credit.prototype.hasChargeDateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional BillingPeriod billing_period = 7;
 * @return {?proto.loopup.ctgateway.v2.BillingPeriod}
 */
proto.loopup.ctgateway.v2.Credit.prototype.getBillingPeriod = function() {
  return /** @type{?proto.loopup.ctgateway.v2.BillingPeriod} */ (
    jspb.Message.getWrapperField(this, proto.loopup.ctgateway.v2.BillingPeriod, 7));
};


/**
 * @param {?proto.loopup.ctgateway.v2.BillingPeriod|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
*/
proto.loopup.ctgateway.v2.Credit.prototype.setBillingPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Credit} returns this
 */
proto.loopup.ctgateway.v2.Credit.prototype.clearBillingPeriod = function() {
  return this.setBillingPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Credit.prototype.hasBillingPeriod = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AdvancedPayment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AdvancedPayment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AdvancedPayment.toObject = function(includeInstance, msg) {
  var f, obj = {
    advancedPaymentAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    coverPeriodStartDateTime: (f = msg.getCoverPeriodStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    numberOfMonthsToCover: jspb.Message.getFieldWithDefault(msg, 3, 0),
    coverPeriodEndDateTime: (f = msg.getCoverPeriodEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    remainingAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    billingEntityName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AdvancedPayment;
  return proto.loopup.ctgateway.v2.AdvancedPayment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AdvancedPayment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAdvancedPaymentAmount(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCoverPeriodStartDateTime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfMonthsToCover(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCoverPeriodEndDateTime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRemainingAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AdvancedPayment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AdvancedPayment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AdvancedPayment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdvancedPaymentAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getCoverPeriodStartDateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNumberOfMonthsToCover();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCoverPeriodEndDateTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRemainingAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getBillingEntityName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional double advanced_payment_amount = 1;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.getAdvancedPaymentAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment} returns this
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.setAdvancedPaymentAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp cover_period_start_date_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.getCoverPeriodStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment} returns this
*/
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.setCoverPeriodStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment} returns this
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.clearCoverPeriodStartDateTime = function() {
  return this.setCoverPeriodStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.hasCoverPeriodStartDateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 number_of_months_to_cover = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.getNumberOfMonthsToCover = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment} returns this
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.setNumberOfMonthsToCover = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp cover_period_end_date_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.getCoverPeriodEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment} returns this
*/
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.setCoverPeriodEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment} returns this
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.clearCoverPeriodEndDateTime = function() {
  return this.setCoverPeriodEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.hasCoverPeriodEndDateTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional double remaining_amount = 5;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.getRemainingAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment} returns this
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.setRemainingAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string billing_entity_name = 6;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.getBillingEntityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment} returns this
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.setBillingEntityName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string currency_code = 7;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment} returns this
 */
proto.loopup.ctgateway.v2.AdvancedPayment.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.Commitment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.Commitment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Commitment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contractStartDateTime: (f = msg.getContractStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    commitmentStartDateTime: (f = msg.getCommitmentStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contractEndDateTime: (f = msg.getContractEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    committedDdis: jspb.Message.getFieldWithDefault(msg, 5, 0),
    pricePerPerfectBundle: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    pricePerCoreSubscription: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.Commitment}
 */
proto.loopup.ctgateway.v2.Commitment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.Commitment;
  return proto.loopup.ctgateway.v2.Commitment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.Commitment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.Commitment}
 */
proto.loopup.ctgateway.v2.Commitment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setContractStartDateTime(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCommitmentStartDateTime(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setContractEndDateTime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCommittedDdis(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPricePerPerfectBundle(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPricePerCoreSubscription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.Commitment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.Commitment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Commitment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractStartDateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCommitmentStartDateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContractEndDateTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCommittedDdis();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPricePerPerfectBundle();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getPricePerCoreSubscription();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
 */
proto.loopup.ctgateway.v2.Commitment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp contract_start_date_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.getContractStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
*/
proto.loopup.ctgateway.v2.Commitment.prototype.setContractStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
 */
proto.loopup.ctgateway.v2.Commitment.prototype.clearContractStartDateTime = function() {
  return this.setContractStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.hasContractStartDateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp commitment_start_date_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.getCommitmentStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
*/
proto.loopup.ctgateway.v2.Commitment.prototype.setCommitmentStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
 */
proto.loopup.ctgateway.v2.Commitment.prototype.clearCommitmentStartDateTime = function() {
  return this.setCommitmentStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.hasCommitmentStartDateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp contract_end_date_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.getContractEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
*/
proto.loopup.ctgateway.v2.Commitment.prototype.setContractEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
 */
proto.loopup.ctgateway.v2.Commitment.prototype.clearContractEndDateTime = function() {
  return this.setContractEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.hasContractEndDateTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 committed_ddis = 5;
 * @return {number}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.getCommittedDdis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
 */
proto.loopup.ctgateway.v2.Commitment.prototype.setCommittedDdis = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double price_per_perfect_bundle = 6;
 * @return {number}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.getPricePerPerfectBundle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
 */
proto.loopup.ctgateway.v2.Commitment.prototype.setPricePerPerfectBundle = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double price_per_core_subscription = 7;
 * @return {number}
 */
proto.loopup.ctgateway.v2.Commitment.prototype.getPricePerCoreSubscription = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.Commitment} returns this
 */
proto.loopup.ctgateway.v2.Commitment.prototype.setPricePerCoreSubscription = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.ChargeGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.ChargeGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.ChargeGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ChargeGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.ChargeGroup}
 */
proto.loopup.ctgateway.v2.ChargeGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.ChargeGroup;
  return proto.loopup.ctgateway.v2.ChargeGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.ChargeGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.ChargeGroup}
 */
proto.loopup.ctgateway.v2.ChargeGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.ChargeGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.ChargeGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.ChargeGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ChargeGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.ChargeGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.ChargeGroup} returns this
 */
proto.loopup.ctgateway.v2.ChargeGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v2.ChargeGroup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.ChargeGroup} returns this
 */
proto.loopup.ctgateway.v2.ChargeGroup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_active = 3;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ChargeGroup.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.ChargeGroup} returns this
 */
proto.loopup.ctgateway.v2.ChargeGroup.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.HierarchyCommitment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.HierarchyCommitment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contractStartDateTime: (f = msg.getContractStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    commitmentStartDateTime: (f = msg.getCommitmentStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contractEndDateTime: (f = msg.getContractEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    committedDdis: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.HierarchyCommitment;
  return proto.loopup.ctgateway.v2.HierarchyCommitment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.HierarchyCommitment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setContractStartDateTime(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCommitmentStartDateTime(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setContractEndDateTime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCommittedDdis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.HierarchyCommitment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.HierarchyCommitment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractStartDateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCommitmentStartDateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContractEndDateTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCommittedDdis();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment} returns this
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp contract_start_date_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.getContractStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment} returns this
*/
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.setContractStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment} returns this
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.clearContractStartDateTime = function() {
  return this.setContractStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.hasContractStartDateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp commitment_start_date_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.getCommitmentStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment} returns this
*/
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.setCommitmentStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment} returns this
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.clearCommitmentStartDateTime = function() {
  return this.setCommitmentStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.hasCommitmentStartDateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp contract_end_date_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.getContractEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment} returns this
*/
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.setContractEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment} returns this
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.clearContractEndDateTime = function() {
  return this.setContractEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.hasContractEndDateTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 committed_ddis = 5;
 * @return {number}
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.getCommittedDdis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment} returns this
 */
proto.loopup.ctgateway.v2.HierarchyCommitment.prototype.setCommittedDdis = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.HierarchyGroup.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.HierarchyGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.HierarchyGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.HierarchyGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    parentGroupId: (f = msg.getParentGroupId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    billingEntity: (f = msg.getBillingEntity()) && proto.loopup.ctgateway.v2.BillingEntity.toObject(includeInstance, f),
    commitmentsList: jspb.Message.toObjectList(msg.getCommitmentsList(),
    proto.loopup.ctgateway.v2.HierarchyCommitment.toObject, includeInstance),
    groupType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.HierarchyGroup;
  return proto.loopup.ctgateway.v2.HierarchyGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.HierarchyGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setParentGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = new proto.loopup.ctgateway.v2.BillingEntity;
      reader.readMessage(value,proto.loopup.ctgateway.v2.BillingEntity.deserializeBinaryFromReader);
      msg.setBillingEntity(value);
      break;
    case 5:
      var value = new proto.loopup.ctgateway.v2.HierarchyCommitment;
      reader.readMessage(value,proto.loopup.ctgateway.v2.HierarchyCommitment.deserializeBinaryFromReader);
      msg.addCommitments(value);
      break;
    case 6:
      var value = /** @type {!proto.loopup.ctgateway.v2.GroupType} */ (reader.readEnum());
      msg.setGroupType(value);
      break;
    case 7:
      var value = /** @type {!proto.loopup.ctgateway.v2.AccountStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.HierarchyGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.HierarchyGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.HierarchyGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParentGroupId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBillingEntity();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.loopup.ctgateway.v2.BillingEntity.serializeBinaryToWriter
    );
  }
  f = message.getCommitmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.loopup.ctgateway.v2.HierarchyCommitment.serializeBinaryToWriter
    );
  }
  f = message.getGroupType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue parent_group_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.getParentGroupId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
*/
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.setParentGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.clearParentGroupId = function() {
  return this.setParentGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.hasParentGroupId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional BillingEntity billing_entity = 4;
 * @return {?proto.loopup.ctgateway.v2.BillingEntity}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.getBillingEntity = function() {
  return /** @type{?proto.loopup.ctgateway.v2.BillingEntity} */ (
    jspb.Message.getWrapperField(this, proto.loopup.ctgateway.v2.BillingEntity, 4));
};


/**
 * @param {?proto.loopup.ctgateway.v2.BillingEntity|undefined} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
*/
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.setBillingEntity = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.clearBillingEntity = function() {
  return this.setBillingEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.hasBillingEntity = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated HierarchyCommitment commitments = 5;
 * @return {!Array<!proto.loopup.ctgateway.v2.HierarchyCommitment>}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.getCommitmentsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.HierarchyCommitment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loopup.ctgateway.v2.HierarchyCommitment, 5));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.HierarchyCommitment>} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
*/
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.setCommitmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.HierarchyCommitment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.HierarchyCommitment}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.addCommitments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.loopup.ctgateway.v2.HierarchyCommitment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.clearCommitmentsList = function() {
  return this.setCommitmentsList([]);
};


/**
 * optional GroupType group_type = 6;
 * @return {!proto.loopup.ctgateway.v2.GroupType}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.getGroupType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.GroupType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.GroupType} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.setGroupType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional AccountStatus status = 7;
 * @return {!proto.loopup.ctgateway.v2.AccountStatus}
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.getStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.AccountStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.AccountStatus} value
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup} returns this
 */
proto.loopup.ctgateway.v2.HierarchyGroup.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.loopup.ctgateway.v2.BillingEntity.oneofGroups_ = [[9,10,11]];

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.BillingEntity.RegionCase = {
  REGION_NOT_SET: 0,
  US_STATE: 9,
  CANADIAN_PROVINCE: 10,
  OTHER_REGION: 11
};

/**
 * @return {proto.loopup.ctgateway.v2.BillingEntity.RegionCase}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getRegionCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.BillingEntity.RegionCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.BillingEntity.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.BillingEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.BillingEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.BillingEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstname: (f = msg.getFirstname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    lastname: (f = msg.getLastname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    emailAddress: (f = msg.getEmailAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    phoneNumber: (f = msg.getPhoneNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address1: (f = msg.getAddress1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address2: (f = msg.getAddress2()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address3: (f = msg.getAddress3()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    usState: jspb.Message.getFieldWithDefault(msg, 9, 0),
    canadianProvince: jspb.Message.getFieldWithDefault(msg, 10, 0),
    otherRegion: (f = msg.getOtherRegion()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    zip: (f = msg.getZip()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    countryCode: (f = msg.getCountryCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    company: (f = msg.getCompany()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    currencyCode: (f = msg.getCurrencyCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 16, ""),
    doNotUploadInvoice: (f = msg.getDoNotUploadInvoice()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity}
 */
proto.loopup.ctgateway.v2.BillingEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.BillingEntity;
  return proto.loopup.ctgateway.v2.BillingEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.BillingEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity}
 */
proto.loopup.ctgateway.v2.BillingEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFirstname(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLastname(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmailAddress(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhoneNumber(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress1(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress2(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress3(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 9:
      var value = /** @type {!proto.loopup.ctgateway.v2.UsState} */ (reader.readEnum());
      msg.setUsState(value);
      break;
    case 10:
      var value = /** @type {!proto.loopup.ctgateway.v2.CanadianProvince} */ (reader.readEnum());
      msg.setCanadianProvince(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOtherRegion(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setZip(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryCode(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCurrencyCode(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setDoNotUploadInvoice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.BillingEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.BillingEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.BillingEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstname();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLastname();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmailAddress();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPhoneNumber();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress1();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress2();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress3();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.UsState} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.CanadianProvince} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getOtherRegion();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getZip();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCurrencyCode();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getDoNotUploadInvoice();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue firstname = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getFirstname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setFirstname = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearFirstname = function() {
  return this.setFirstname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasFirstname = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue lastname = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getLastname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setLastname = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearLastname = function() {
  return this.setLastname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasLastname = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue email_address = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getEmailAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setEmailAddress = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearEmailAddress = function() {
  return this.setEmailAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasEmailAddress = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue phone_number = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getPhoneNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearPhoneNumber = function() {
  return this.setPhoneNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasPhoneNumber = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue address1 = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getAddress1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setAddress1 = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearAddress1 = function() {
  return this.setAddress1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasAddress1 = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue address2 = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getAddress2 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setAddress2 = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearAddress2 = function() {
  return this.setAddress2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasAddress2 = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue address3 = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getAddress3 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setAddress3 = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearAddress3 = function() {
  return this.setAddress3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasAddress3 = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue city = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasCity = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional UsState us_state = 9;
 * @return {!proto.loopup.ctgateway.v2.UsState}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getUsState = function() {
  return /** @type {!proto.loopup.ctgateway.v2.UsState} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.UsState} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.setUsState = function(value) {
  return jspb.Message.setOneofField(this, 9, proto.loopup.ctgateway.v2.BillingEntity.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearUsState = function() {
  return jspb.Message.setOneofField(this, 9, proto.loopup.ctgateway.v2.BillingEntity.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasUsState = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional CanadianProvince canadian_province = 10;
 * @return {!proto.loopup.ctgateway.v2.CanadianProvince}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getCanadianProvince = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CanadianProvince} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CanadianProvince} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.setCanadianProvince = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.loopup.ctgateway.v2.BillingEntity.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearCanadianProvince = function() {
  return jspb.Message.setOneofField(this, 10, proto.loopup.ctgateway.v2.BillingEntity.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasCanadianProvince = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue other_region = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getOtherRegion = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setOtherRegion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.loopup.ctgateway.v2.BillingEntity.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearOtherRegion = function() {
  return this.setOtherRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasOtherRegion = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue zip = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getZip = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setZip = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearZip = function() {
  return this.setZip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasZip = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue country_code = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getCountryCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setCountryCode = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearCountryCode = function() {
  return this.setCountryCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue company = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getCompany = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setCompany = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue currency_code = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getCurrencyCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearCurrencyCode = function() {
  return this.setCurrencyCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasCurrencyCode = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string id = 16;
 * @return {string}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional google.protobuf.BoolValue do_not_upload_invoice = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.getDoNotUploadInvoice = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
*/
proto.loopup.ctgateway.v2.BillingEntity.prototype.setDoNotUploadInvoice = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.BillingEntity} returns this
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.clearDoNotUploadInvoice = function() {
  return this.setDoNotUploadInvoice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.BillingEntity.prototype.hasDoNotUploadInvoice = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.BillingPeriodStatus = {
  BILLING_PERIOD_STATUS_INVALID: 0,
  BILLING_PERIOD_STATUS_OPEN: 1,
  BILLING_PERIOD_STATUS_SOFT_CLOSED: 2,
  BILLING_PERIOD_STATUS_HARD_CLOSED: 3,
  BILLING_PERIOD_STATUS_ARCHIVED: 4
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.AccountStatus = {
  ACCOUNT_STATUS_INVALID: 0,
  ACCOUNT_STATUS_ACTIVE: 1,
  ACCOUNT_STATUS_PENDING_FINAL_BILL: 2,
  ACCOUNT_STATUS_CLOSED: 3
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.UsState = {
  US_STATE_INVALID: 0,
  US_STATE_AL: 1,
  US_STATE_AK: 2,
  US_STATE_AZ: 3,
  US_STATE_AR: 4,
  US_STATE_CA: 5,
  US_STATE_CO: 6,
  US_STATE_CT: 7,
  US_STATE_DE: 8,
  US_STATE_DC: 9,
  US_STATE_FL: 10,
  US_STATE_GA: 11,
  US_STATE_HI: 12,
  US_STATE_ID: 13,
  US_STATE_IL: 14,
  US_STATE_IN: 15,
  US_STATE_IA: 16,
  US_STATE_KS: 17,
  US_STATE_KY: 18,
  US_STATE_LA: 19,
  US_STATE_ME: 20,
  US_STATE_MD: 21,
  US_STATE_MA: 22,
  US_STATE_MI: 23,
  US_STATE_MN: 24,
  US_STATE_MS: 25,
  US_STATE_MO: 26,
  US_STATE_MT: 27,
  US_STATE_NE: 28,
  US_STATE_NV: 29,
  US_STATE_NH: 30,
  US_STATE_NJ: 31,
  US_STATE_NM: 32,
  US_STATE_NY: 33,
  US_STATE_NC: 34,
  US_STATE_ND: 35,
  US_STATE_OH: 36,
  US_STATE_OK: 37,
  US_STATE_OR: 38,
  US_STATE_PA: 39,
  US_STATE_RI: 40,
  US_STATE_SC: 41,
  US_STATE_SD: 42,
  US_STATE_TN: 43,
  US_STATE_TX: 44,
  US_STATE_UT: 45,
  US_STATE_VT: 46,
  US_STATE_VA: 47,
  US_STATE_WA: 48,
  US_STATE_WV: 49,
  US_STATE_WI: 50,
  US_STATE_WY: 51
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.CanadianProvince = {
  CANADIAN_PROVINCE_INVALID: 0,
  CANADIAN_PROVINCE_AB: 1,
  CANADIAN_PROVINCE_BC: 2,
  CANADIAN_PROVINCE_MB: 3,
  CANADIAN_PROVINCE_NB: 4,
  CANADIAN_PROVINCE_NF: 5,
  CANADIAN_PROVINCE_NT: 6,
  CANADIAN_PROVINCE_NS: 7,
  CANADIAN_PROVINCE_NU: 8,
  CANADIAN_PROVINCE_ON: 9,
  CANADIAN_PROVINCE_PE: 10,
  CANADIAN_PROVINCE_PQ: 11,
  CANADIAN_PROVINCE_SK: 12,
  CANADIAN_PROVINCE_YT: 13
};

goog.object.extend(exports, proto.loopup.ctgateway.v2);
